import { API } from "./utils"


export const digital = {
  digitalFilesList: (params = null) => API.get("/digital/files/", { params }),
  digitalFileErrorsList: (id, params) => API.get(`/digital/files/${id}/errors/`, { params }),
}
